<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.roomNo') }}</div>
                <input v-model="searchParams.roomId" type="text" />
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.reason') }}</div>
                <el-select
                  v-model="searchParams.reason"
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in reasonOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.desc"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.roomStatus') }}</div>
                <el-select v-model="searchParams.status" placeholder="">
                  <el-option
                    v-for="item in roomStatusOptions"
                    :key="item.id"
                    :value="item.value"
                    :label="item.label"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.oooAndOosRoomReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              :default-col-def="defaultColDef"
              class="agGrid"
              dom-layout="scroll"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <ul>
              <li>Số phòng: Hiển thị Số phòng</li>
              <li>
                Từ ngày: Hiển thị Từ ngày phòng không sử dụng/không phục vụ.
                Format: DD/MM/YYYY
              </li>
              <li>
                Đến ngày: Hiển thị Đến ngày phòng không sử dụng/không phục vụ.
                Format: DD/MM/YYYY
              </li>
              <li>Trạng thái phòng: Hiển thị trạng thái phòng</li>
              <li>
                Lý do: Hiển thị Lý do không sử dụng/không phục vụ của phòng
              </li>
              <li>
                Thời gian tạo: Hiển thị thời gian thực hiện cập nhật trạng thái
                phòng về không sử dụng/không phục vụ. Format : DD/MM/YYYY
                HH:MM:SS
              </li>
              <li>
                Người tạo: Hiển thị họ và tên tài khoản tạo phòng không sử
                dụng/không phục vụ
              </li>
              <li>Dữ liệu được lấy từ Buồng phòng</li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { getAllHotel } from '@/api/hotel.js'
import InfoBtn from './components/InfoBtn.vue'
import {
  getOooAndOosReportApi,
  getOooAndOosReportApiExcel
} from '@/api/report_service/report'
import { dateTimeFormatter } from '@/utils/dataFormatter'
import moment from 'moment'
import { getReasonListApi } from '@/api/common/code'
import { downFile } from '@/utils/file-handler'
const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelIdList: null,
  roomId: null,
  status: 0,
  reason: null
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      datetimeRange: { start: '2023-12-12', end: '2023-12-15' },
      roomStatusOptions: [
        {
          id: 1,
          label: 'Tất cả',
          value: 0
        },
        {
          id: 2,
          label: 'OOO',
          value: 1
        },
        {
          id: 3,
          label: 'OOS',
          value: 2
        }
      ],
      hotelOptions: [],
      reasonOptions: [],
      gridLoading: false,
      columns: [
        {
          headerName: this.$t('grid.column.roomNo'),
          field: 'roomNum',
          tooltipField: 'roomNum',
          minWidth: 100,
          maxWidth: 100,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.fromDate'),
          field: 'dateFrom',

          minWidth: 120,
          maxWidth: 120,
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.toDate'),
          field: 'dateTo',

          minWidth: 120,
          maxWidth: 120,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomState'),
          field: 'statusString',
          tooltipField: 'statusString',
          minWidth: 120,
          maxWidth: 140,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.reason'),
          field: 'reasonString',
          tooltipField: 'reasonString',
          minWidth: 200,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.createdTime'),
          field: 'createDate',
          tooltipValueGetter: params => {
            return params.value ? dateTimeFormatter(params.value) : null
          },
          valueFormatter: params => {
            return params.value ? dateTimeFormatter(params.value) : null
          },
          minWidth: 180,
          maxWidth: 180,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.createdPerson'),
          field: 'createUser',
          tooltipField: 'createUser',
          minWidth: 150,
          maxWidth: 200,
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        }
      ],
      rows: []
    }
  },
  async mounted() {
    await this.getHotelOptions()
    this.getListReason()
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    getDefaultSearchParams() {
      return {
        ...getDefaultSearchParams()
      }
    },
    async getListReason() {
      const data = await getReasonListApi()
      this.reasonOptions = data.data
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = this.getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },

    async attachData() {
      this.gridLoading = true
      await getOooAndOosReportApi(this.searchParams)
        .then(res => {
          this.rows = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    async downloadExcel() {
      this.gridLoading = true
      await getOooAndOosReportApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_phong_ooo_oos_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    }
  }
}
</script>

<style></style>
